import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {isHideDisabled} from '../../actions/Field';
import {getFieldPack} from '../../actions/Packages';
import TooltipedImg from '../../../../../components/Common/TooltipedImg';
import {textConst, texts, getLocalizedText} from '../../../../../constants/TextConst';
import {Loader} from 'semantic-ui-react';
import {packageConsts} from '../../../../../constants';
import ActionsMenu, {ActionItem} from '../../../../../components/Common/ActionsMenu';
import packageImage from '../../../../../images/package.png';
import packageHiddenImage from '../../../../../images/package_hidden.png';
import moduleHiddenImage from '../../../../../images/module_hidden.png';
import arrowLeftImage from '../../../../../images/arrow_left.png';
import HideSubmenu from './HideMenu';

export interface MenuProps {
    field: any;
}

@observer
export default class MainMenuActionsMenu extends Component<MenuProps & {open: boolean}, any> {
    renderBasicActions() {
        const {field} = this.props;

        return (
            <div className="actions1">
                <ActionItem
                    title={
                        field.hidden ? getLocalizedText(texts.show) : getLocalizedText(texts.hide)
                    }
                    disabled={isHideDisabled(field)}
                    icon={<img alt={textConst.moreAlt} src={arrowLeftImage} />}
                >
                    <HideSubmenu field={field} outsideClickIgnoreClass={'action-tab-open'} />
                </ActionItem>
            </div>
        );
    }

    renderPackageData() {
        const {field} = this.props;
        const activeFieldPack = getFieldPack(field);
        const packageTitle = activeFieldPack ? activeFieldPack.title : '';
        const packageHidden = activeFieldPack && activeFieldPack.hidden;
        const moduleHidden = activeFieldPack && activeFieldPack.moduleHidden;

        return (
            <div className="package-wrapper">
                {activeFieldPack ? (
                    <div>
                        <div className={`package ${packageHidden && 'hidden'}`}>
                            {moduleHidden ? (
                                <TooltipedImg
                                    src={moduleHiddenImage}
                                    alt={textConst.moduleHiddenAlt}
                                    tooltipText={getLocalizedText(texts.moduleHiddenTooltip)}
                                    height={50}
                                />
                            ) : (
                                <img
                                    alt={textConst.hiddenSignAlt}
                                    src={packageHidden ? packageHiddenImage : packageImage}
                                />
                            )}
                            <span>{getLocalizedText(texts.pack)}</span>
                        </div>
                        {field.packId !== packageConsts.PERM_UNASSIGNED_PAC_ID && (
                            <span>{packageTitle}</span>
                        )}
                    </div>
                ) : (
                    <Loader active />
                )}
            </div>
        );
    }

    render() {
        return this.props.open ? (
            <ActionsMenu open={this.props.open}>
                {this.renderBasicActions()}
                {this.renderPackageData()}
            </ActionsMenu>
        ) : null;
    }
}
